import RatingList from './RatingList';

export default RatingList;
